const NormalizeSpace = (value: any, previousValue: any) => {
  const trimmedValue = value.trimStart();
  return trimmedValue;
};

export default NormalizeSpace;
